import React, { useState, useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import Cookies from 'js-cookie';
import { logout } from '@utils/utils';
import CompanySelector from './companySelector';
import ProfileDropdown from './ProfileDropdown'; // import at top
import VoiceAssistant from './VoiceAssist/VoiceAssistant';
import {
  Bell, Mail, Clock, Eye, EyeOff, LogOut, ArrowDown, Globe, ArrowLeft
} from 'lucide-react';
import { API_BASE_URL,APP_BASE_URL } from '../config';
import MiniAssistant from './VoiceAssist/MiniAssistant';
import Webtrix24LogoAnimated from './Webtrix24LogoAnimated';

const mockNotifications = [
  { id: 1, type: 'email', title: 'New Email Received', message: 'You have a new message from support.', time: '2 min ago', read: false },
  { id: 2, type: 'reminder', title: 'Task Reminder', message: 'Follow up with client X.', time: '1 hour ago', read: false },
  { id: 3, type: 'watcher', title: 'Added as Watcher', message: 'You are now watching Lead #123.', time: 'Yesterday', read: true },
  { id: 4, type: 'email', title: 'New Email Received', message: 'You have a new message from support.', time: '2 min ago', read: false },
  { id: 5, type: 'reminder', title: 'Task Reminder', message: 'Follow up with client X.', time: '1 hour ago', read: false },
  { id: 6, type: 'watcher', title: 'Added as Watcher', message: 'You are now watching Lead #123.', time: 'Yesterday', read: true },
  { id: 7, type: 'email', title: 'New Email Received', message: 'You have a new message from support.', time: '2 min ago', read: false },
  { id: 8, type: 'reminder', title: 'Task Reminder', message: 'Follow up with client X.', time: '1 hour ago', read: false },
  { id: 9, type: 'watcher', title: 'Added as Watcher', message: 'You are now watching Lead #123.', time: 'Yesterday', read: true },
  { id: 10, type: 'email', title: 'New Email Received', message: 'You have a new message from support.', time: '2 min ago', read: false },
  { id: 11, type: 'reminder', title: 'Task Reminder', message: 'Follow up with client X.', time: '1 hour ago', read: false },
  { id: 12, type: 'watcher', title: 'Added as Watcher', message: 'You are now watching Lead #123.', time: 'Yesterday', read: true },
];

const iconMap = {
  email: <Mail className="text-blue-500" size={18} />,
  reminder: <Clock className="text-orange-500" size={18} />,
  watcher: <Eye className="text-green-500" size={18} />,
};

const TopNavBar = () => {
  const navigate = useNavigate();
  const dropdownRef = useRef(null);
  const dropdownProfileRef = useRef(null);
  const [notifications, setNotifications] = useState(mockNotifications);
  const [showDropdown, setShowDropdown] = useState(false);
  const [showProfileDropdown, setShowProfileDropdown] = useState(false);
  const [showMobileNotificationPage, setShowMobileNotificationPage] = useState(false);
  const unreadCount = 0;//notifications.filter(n => !n.read).length;
  const userData = JSON.parse(localStorage.getItem('user'));
  const [selectedCompany, setSelectedCompany] = useState(localStorage.getItem('active_company') || userData?.default_company);
  const [dateTime, setDateTime] = useState(new Date());
  const systemTZ = Intl.DateTimeFormat().resolvedOptions().timeZone;
  const [timeZone, setTimeZone] = useState(localStorage.getItem('user_time_zone') || systemTZ);

  const avatar = userData?.['photo']
      ? `${APP_BASE_URL}/uploads/profilephoto/${userData?.['adminID']}/profilePic/${userData?.['photo']}`
      : null;
  
    const initials = userData?.['name']
      ? userData?.['name']
          .split(' ')
          .map((n) => n[0])
          .join('')
          .substring(0, 2)
          .toUpperCase()
      : 'U';
  

  useEffect(() => {
    const timer = setInterval(() => setDateTime(new Date()), 1000);
    return () => clearInterval(timer);
  }, []);

  useEffect(() => {
    // get user details
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setShowDropdown(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  useEffect(() => {
  const handleClickOutsideProfile = (event) => {
    if (
      dropdownProfileRef.current &&
      !dropdownProfileRef.current.contains(event.target)
    ) {
      setShowProfileDropdown(false);
    }
  };

  document.addEventListener('mousedown', handleClickOutsideProfile);
  return () => {
    document.removeEventListener('mousedown', handleClickOutsideProfile);
  };
}, []);



  const handleLogout = () => {
    logout();
    navigate('/login');
  };

  const toggleRead = (id) => {
    setNotifications(prev =>
      prev.map(n => n.id === id ? { ...n, read: !n.read } : n)
    );
  };

  return (
    // <header className="w-full fixed top-0 left-0 z-50 bg-white shadow-sm border-b px-4 py-2 pl-10 lg:pl-2 flex flex-wrap justify-between items-center gap-4"></header>
    <header className="w-full fixed top-0 left-0 z-50 bg-[#2d385b] px-4 py-1 pl-10 lg:pl-2 flex flex-wrap justify-between items-center gap-4">
      {/* Left Section: Logo & Company */}
      <div className="flex items-left gap-2">
        <div className="w-16 h-8 rounded-md flex items-center justify-center text-indigo-700 text-lg">
          <div className="align-center flex item-left justify-start pt-1">
              <a href='/'>
              {/* <Webtrix24LogoAnimated
                className="w-full"
                webtrixProps={{
                  whileHover: { scale: 1.04 },
                  transition: { duration: 0.7, type: "spring", stiffness: 200 }
                }}
                twentyFourProps={{
                  whileHover: { scale: 1.09, rotate: 2 },
                  transition: { duration: 0.6, type: "spring", stiffness: 240, delay: 0.6 }
                }}
              /> */}
              <svg className="w-8 h-8 mt-2" viewBox="0 0 142 137">
                    <defs>
                      {/* REAL PATH GROUP FOR CLIPPING */}
                      <clipPath id="logoClip">
                        <path d="M101.435 0.77224C97.6358 5.05397 93.9107 12.3256 92.9421 17.4932C92.6814 18.822 92.6814 25.503 92.905 27.0902C93.4637 30.8184 96.183 39.0127 98.5298 44.0694C98.8279 44.6602 99.6473 46.5795 100.355 48.2773C101.734 51.5257 105.198 57.3947 110.45 65.4783C124.196 86.5547 129.597 97.3328 131.534 107.299C132.093 110.289 131.758 116.342 130.827 119.923C130.007 122.95 129.001 126.013 128.48 127.01C127.623 128.56 128.629 127.453 130.193 125.054C135.856 116.49 138.202 109.698 138.202 101.91C138.202 95.3027 137.308 91.6485 133.62 83.0112C130.938 76.81 129.337 73.4512 127.362 70.0184L125.5 66.8071L127.586 61.5287C128.74 58.6127 130.938 53.076 132.428 49.2371C133.956 45.3614 136.526 38.8649 138.128 34.7309L141.071 27.2747H128.145H115.218L112.424 34.9155C110.86 39.1234 109.445 42.6299 109.258 42.667C108.848 42.8145 104.974 36.4658 102.516 31.6671C96.2201 19.3018 95.9595 10.4431 101.696 1.25209C102.628 -0.224371 102.516 -0.408928 101.435 0.77224Z"/>
                        <path d="M76.8866 13.3577C72.8263 18.3039 70.8147 21.9581 69.5108 26.8304C68.7657 29.5989 67.2758 32.5516 59.4158 46.6888C54.3495 55.8059 48.7246 65.8827 46.9737 69.0572C45.2231 72.2317 43.6586 74.7415 43.5094 74.5939C43.3976 74.4464 41.7587 70.2753 39.8961 65.2922C38.0334 60.3092 34.1221 49.7526 31.1421 41.8533L25.7779 27.4579L12.8889 27.3472C5.8112 27.3103 0 27.3472 0 27.421C0 27.5318 0.93128 29.9679 2.08607 32.8838C3.24086 35.8 8.19527 48.4606 13.1124 61.0475C18.0296 73.6342 25.5544 92.902 29.8754 103.865C34.1595 114.827 38.1826 125.163 38.8157 126.861C39.7472 129.334 40.0824 129.851 40.4177 129.444C41.4606 128.337 65.9347 85.4091 67.9834 81.0905C69.2127 78.5065 70.3303 76.3657 70.4795 76.3657C70.5912 76.3657 71.8948 78.4697 73.3105 81.0534C74.7261 83.6742 81.4685 95.7074 88.2109 107.851L100.504 129.924L99.6472 132.434C99.1627 133.837 98.604 135.313 98.3805 135.756C98.0826 136.273 98.0826 136.531 98.3433 136.531C98.9767 136.531 102.292 131.77 104.266 128.042C107.023 122.8 108.066 118.925 108.289 112.982C108.438 109.955 108.327 107.002 108.029 105.231C107.284 100.358 101.771 85.1876 98.8275 79.7617C95.2142 73.0805 88.9188 62.1548 87.019 59.2757C84.3369 55.2154 80.3509 47.6486 77.8552 41.8904C72.5282 29.5989 72.6399 20.6662 78.2648 12.2135C79.4569 10.4048 78.9727 10.8108 76.8866 13.3577Z"/>
                      </clipPath>
                    </defs>

                    {/* Blue logo fill */}
                    <g fill="#fff">
                      <path d="M101.435 0.77224C97.6358 5.05397 93.9107 12.3256 92.9421 17.4932C92.6814 18.822 92.6814 25.503 92.905 27.0902C93.4637 30.8184 96.183 39.0127 98.5298 44.0694C98.8279 44.6602 99.6473 46.5795 100.355 48.2773C101.734 51.5257 105.198 57.3947 110.45 65.4783C124.196 86.5547 129.597 97.3328 131.534 107.299C132.093 110.289 131.758 116.342 130.827 119.923C130.007 122.95 129.001 126.013 128.48 127.01C127.623 128.56 128.629 127.453 130.193 125.054C135.856 116.49 138.202 109.698 138.202 101.91C138.202 95.3027 137.308 91.6485 133.62 83.0112C130.938 76.81 129.337 73.4512 127.362 70.0184L125.5 66.8071L127.586 61.5287C128.74 58.6127 130.938 53.076 132.428 49.2371C133.956 45.3614 136.526 38.8649 138.128 34.7309L141.071 27.2747H128.145H115.218L112.424 34.9155C110.86 39.1234 109.445 42.6299 109.258 42.667C108.848 42.8145 104.974 36.4658 102.516 31.6671C96.2201 19.3018 95.9595 10.4431 101.696 1.25209C102.628 -0.224371 102.516 -0.408928 101.435 0.77224Z"/>
                      <path d="M76.8866 13.3577C72.8263 18.3039 70.8147 21.9581 69.5108 26.8304C68.7657 29.5989 67.2758 32.5516 59.4158 46.6888C54.3495 55.8059 48.7246 65.8827 46.9737 69.0572C45.2231 72.2317 43.6586 74.7415 43.5094 74.5939C43.3976 74.4464 41.7587 70.2753 39.8961 65.2922C38.0334 60.3092 34.1221 49.7526 31.1421 41.8533L25.7779 27.4579L12.8889 27.3472C5.8112 27.3103 0 27.3472 0 27.421C0 27.5318 0.93128 29.9679 2.08607 32.8838C3.24086 35.8 8.19527 48.4606 13.1124 61.0475C18.0296 73.6342 25.5544 92.902 29.8754 103.865C34.1595 114.827 38.1826 125.163 38.8157 126.861C39.7472 129.334 40.0824 129.851 40.4177 129.444C41.4606 128.337 65.9347 85.4091 67.9834 81.0905C69.2127 78.5065 70.3303 76.3657 70.4795 76.3657C70.5912 76.3657 71.8948 78.4697 73.3105 81.0534C74.7261 83.6742 81.4685 95.7074 88.2109 107.851L100.504 129.924L99.6472 132.434C99.1627 133.837 98.604 135.313 98.3805 135.756C98.0826 136.273 98.0826 136.531 98.3433 136.531C98.9767 136.531 102.292 131.77 104.266 128.042C107.023 122.8 108.066 118.925 108.289 112.982C108.438 109.955 108.327 107.002 108.029 105.231C107.284 100.358 101.771 85.1876 98.8275 79.7617C95.2142 73.0805 88.9188 62.1548 87.019 59.2757C84.3369 55.2154 80.3509 47.6486 77.8552 41.8904C72.5282 29.5989 72.6399 20.6662 78.2648 12.2135C79.4569 10.4048 78.9727 10.8108 76.8866 13.3577Z"/>
                    </g>

                    {/* SHINE EFFECT */}
                    <foreignObject width="142" height="137" clipPath="url(#logoClip)">
                      <div className="shine-effect"></div>
                    </foreignObject>

                    <foreignObject width="142" height="137" clipPath="url(#logoClip)">
                      <div className="shine-effect w-full h-full"></div>
                    </foreignObject>
                </svg>
              </a>
            </div></div>
        <CompanySelector />
      </div>

      {/* Right Section: Responsive container */}
      <div className="flex flex-wrap items-center gap-4 justify-end text-sm text-gray-100">
        {/* Time & Timezone - hidden on small screens */}
        <div className="hidden md:flex items-center gap-2 text-gray-100">
          <Clock className="w-4 h-4 text-indigo-500" />
          <span>{dateTime.toLocaleString('en-IN', { dateStyle: 'medium', timeStyle: 'short', hour12: true, timeZone })}</span>
          <Globe className="w-4 h-4 text-green-600 bg-transparent" />
          <select
            value={timeZone}
            onChange={(e) => {
              const selected = e.target.value;
              setTimeZone(selected);
              localStorage.setItem('user_time_zone', selected);
            }}
            className="rounded px-2 py-1 bg-transparent focus:outline-none"
          >
            <option value="Asia/Kolkata">India (IST)</option>
            <option value="UTC">UTC</option>
            <option value="America/New_York">US (EST)</option>
            <option value="Europe/London">UK (GMT)</option>
            <option value="Asia/Dubai">Dubai</option>
            <option value="Asia/Singapore">Singapore</option>
          </select>
        </div>

        {/* Bell icon - mobile opens full panel */}
        <div className="relative cursor-pointer md:block" onClick={() => {
            setShowDropdown(!showDropdown);
        }}>
          <div className="relative flex items-center justify-center">
            <span className={`absolute inset-0 ${unreadCount > 0 ? 'animate-ping  rounded-full bg-red-300' : ''}`}></span>
            <Bell className={`relative z-10 w-5 h-5 ${unreadCount > 0 ? 'text-white' : 'text-gray-100'}`} />
            {unreadCount > 0 && (
              <span className="absolute -top-2 -right-1.5 translate-x-1 z-20 bg-red-500 text-white text-xs rounded-full w-4 h-4 flex items-center justify-center">
                {unreadCount}
              </span>
            )}
          </div>
        </div>
        <div className='fixed bottom-2'>
          {/* <MiniAssistant /> */}
        </div>
        {/* Notification dropdown for desktop */}
        {showDropdown && (
          <div className="fixed md:absolute top-0 md:top-12 right-0 md:right-20 left-0 md:left-auto bottom-0 md:bottom-auto w-full md:w-80 md:h-auto h-full md:max-h-96 overflow-y-auto bg-white border rounded md:shadow-lg z-50">
            {/* Header for mobile */}
            <div className="flex items-center justify-between p-3 border-b sticky top-0 bg-white z-10 md:hidden">
              <div className="flex items-center gap-2">
                <ArrowLeft className="cursor-pointer" onClick={() => setShowDropdown(false)} />
                <h2 className="text-lg font-semibold">Notifications</h2>
              </div>
            </div>

            {/* Title for desktop */}
            <div className="font-medium text-sm truncate sticky top-0 bg-white z-10 px-4 py-2 border-b shadow-sm hidden md:block">
              Notifications
            </div>

            {/* Notification list */}
            <div className="px-3 py-2">
              {notifications.length === 0 ? (
                <div className="text-gray-500 text-sm">No notifications</div>
              ) : notifications.map(n => (
                <div key={n.id} className={`flex items-start justify-between gap-2 px-2 py-2 hover:bg-gray-100 rounded ${n.read ? 'opacity-60' : ''}`} tabIndex="0" aria-label={`Notification: ${n.title}`}>  
                  <div className="flex gap-2 flex-1 min-w-0">
                    <div className="mt-1 flex-shrink-0">{iconMap[n.type]}</div>
                    <div className="min-w-0">
                      <div
                        className="font-medium text-sm truncate"
                        title={n.title}
                      >{n.title}
                      </div>
                      <div
                        className="text-xs text-gray-500 truncate"
                        title={n.message}
                      >{n.message}
                      </div>
                    </div>
                  </div>
                  <div className="flex flex-col items-end justify-between text-xs text-gray-400 whitespace-nowrap">
                    <span>{n.time}</span>
                    <button
                      onClick={() => toggleRead(n.id)}
                      className="text-blue-500 hover:underline p-1 rounded hover:bg-blue-50"
                    >
                      {n.read ? <EyeOff size={14} /> : <Eye size={14} />}
                    </button>
                  </div>
                </div>
              ))}
            </div>
          </div>

      )}
        {/* Profile & Logout */}
        {/* <div className="flex items-center gap-2">
               {avatar ? (
          <img
            src={avatar}
            alt={userData['name']}
            className="w-8 h-8 rounded-full object-cover"
          />
        ) : (
          <div className="w-8 h-8 bg-gray-400 rounded-full flex items-center justify-center text-white font-bold text-sm">
            {initials}
          </div>
        )}
          {/* <img src="https://i.pravatar.cc/30?img=3" alt="User" className="w-8 h-8 rounded-full" /> * /}
          <span className="font-medium hidden sm:inline">{ userData?.['name']}</span>
        </div>
        <button
          onClick={handleLogout}
          className="flex items-center gap-1 text-sm text-gray-600 hover:text-red-500"
        >
          <LogOut className="w-4 h-4" />
          <span className="hidden sm:inline">Logout</span>
        </button> */}
        <div ref={dropdownProfileRef} className="relative">
  <button
    className="flex items-center gap-1 cursor-pointer"
    onClick={(e) => {e.preventDefault(); setShowProfileDropdown((prev) => !prev);}}
  >
    {avatar ? (
      <img src={avatar} className="w-8 h-8 rounded-full" />
    ) : (
      <div className="w-8 h-8 bg-gray-400 rounded-full flex items-center justify-center text-white font-bold text-sm">
        {initials}
      </div>
    )}
    <svg
      className={`w-4 h-4 transition-transform duration-200 ${
        showProfileDropdown ? 'rotate-180' : ''
      }`}
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      viewBox="0 0 24 24"
    >
      <path d="M19 9l-7 7-7-7" />
    </svg>
  </button>

  {showProfileDropdown && (
    <ProfileDropdown
      user={userData}
      onLogout={handleLogout}
      onClose={() => setShowProfileDropdown(false)}
    />
  )}
</div>
      </div>
      
    </header>
  );
};

export default TopNavBar;